<template>
  <base-edit></base-edit>
</template>

<script>
  import BaseEdit from './baseEdit';

  export default {
    name: 'businessReceiptEdit',
    components: {
      BaseEdit,
    },
  };
</script>
